import { RootState } from 'app/redux/state/root-state';
import { BillingAccount } from 'app/page/orders/model/billing-account';
import { PendingAction } from 'app/page/orders/redux/model/pending-action';
import { OrdersState } from 'app/page/orders/redux/model/orders-state';
import { CustomerInformation } from 'app/page/orders/model/customer-information';

export const selectOrders = (state: RootState): OrdersState => state.orders;

export const selectBillingAccountId = (state: RootState): string | undefined =>
    selectOrders(state).selectedBillingAccountId;

export const selectBillingAccountIdOrThrow = (state: RootState): string =>
    selectBillingAccountId(state) ||
    (() => {
        throw new Error('Billing account must be selected.');
    })();

export const selectBillingAccounts = (state: RootState): BillingAccount[] => selectOrders(state).billingAccounts;

export const selectBillingAccount = (state: RootState): BillingAccount | undefined =>
    selectBillingAccounts(state).find((billingAccount) => billingAccount.accountId === selectBillingAccountId(state));

export const selectCustomerInformation = (state: RootState): CustomerInformation | undefined =>
    selectBillingAccount(state)?.customerInformation;

export const selectOrderId = (state: RootState): string | undefined => selectBillingAccount(state)?.selectedOrderId;

export const selectOrder = (state: RootState): OrderTrackerBackend.Order | undefined => {
    const orderId = selectOrderId(state);

    return orderId ? selectBillingAccount(state)?.activeOrders[orderId]?.order : undefined;
};

export const selectServiceAddress = (state: RootState): OrderTrackerBackend.DeliveryServiceAddress | undefined =>
    selectOrder(state)?.deliveryServiceAddress;

export const selectPendingActions = (state: RootState): PendingAction[] => state.orders.pendingActions;
